import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import PresentationalUniversalBlockView, {
  PresentationalUniversalBlockViewProps,
} from 'insights/universal-blocks/PresentationalUniversalBlockView';
import ToggleExpandButton from 'ui-library/buttons/ToggleExpandButton';

/** @package */
export interface SharedModelingBlockProps {
  dashboardClientStateId: string;
  isExpanded: boolean;
  onToggleExpand: (newIsExpanded: boolean) => void;
  toolbarExtension?: ReactNode;
}

/** @package */
export type ModelingDashboardBlockProps = SharedModelingBlockProps &
  Pick<PresentationalUniversalBlockViewProps, 'inputDataFrame' | 'visualizationConfig'> & {
    blockTitle: string;
    blockDescription: string;
  };

export default function ModelingDashboardBlock({
  blockTitle,
  blockDescription,
  dashboardClientStateId,
  inputDataFrame,
  visualizationConfig,
  isExpanded,
  onToggleExpand,

  toolbarExtension,
}: ModelingDashboardBlockProps): JSX.Element {
  return (
    <PresentationalUniversalBlockView
      actionOrigin={ActionOrigin.MACHINE_LEARNING}
      inputDataFrame={inputDataFrame}
      paneProps={{
        description: blockDescription,
        title: blockTitle,
        toolbar: (
          <div className={css(styles.toolbar)}>
            {toolbarExtension}
            <ToggleExpandButton isExpanded={isExpanded} onChange={onToggleExpand} />
          </div>
        ),
      }}
      viewStateId={`${blockTitle} - ${dashboardClientStateId}`}
      visualizationConfig={visualizationConfig}
    />
  );
}

const styles = StyleSheet.create({
  toolbar: {display: 'flex', alignItems: 'center', flexDirection: 'row'},
});
